"use client";

import React, { useEffect } from "react";
import { Button, Tooltip } from "antd";
import useDomainStore from "../stores/domainStore.ts";

export default function DomainSwitcher() {
  const { 
    currentDomain, 
    initializeDomain, 
    toggleDomain, 
    getDomainLabel, 
    getDomainColor, 
    getDomainIcon 
  } = useDomainStore();

  useEffect(() => {
    initializeDomain();
  }, [initializeDomain]);

  const getNextDomainLabel = () => {
    const domainOrder = ["local", "dev", "production"];
    const currentIndex = domainOrder.indexOf(currentDomain);
    const nextIndex = (currentIndex + 1) % domainOrder.length;
    const nextDomain = domainOrder[nextIndex];
    const labels = {
      local: "Local",
      dev: "Dev",
      production: "Production",
    };
    return labels[nextDomain as keyof typeof labels] || "Unknown";
  };

  // Chỉ hiển thị trong development
  if (process.env.NODE_ENV === "production") {
    return null;
  }

  return (
    <Tooltip title={`Current: ${getDomainLabel()} | Click to switch to ${getNextDomainLabel()}`}>
      <Button
        type="primary"
        shape="circle"
        size="large"
        onClick={toggleDomain}
        className="fixed bottom-6 right-6 z-50 shadow-lg"
        style={{
          backgroundColor: getDomainColor(),
          borderColor: getDomainColor(),
          width: "56px",
          height: "56px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="flex flex-col items-center gap-1">
          <i className={`fa-solid ${getDomainIcon()} text-white text-lg`}></i>
          <span className="text-xs text-white font-bold">{getDomainLabel()}</span>
        </div>
      </Button>
    </Tooltip>
  );
}

